import { forwardRef } from "react";
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { TooltipComponent, GridComponent, VisualMapComponent, GraphicComponent } from 'echarts/components';
import * as echarts from 'echarts/core';
import { SVGRenderer } from 'echarts/renderers';

const Echart = forwardRef(({ charts, props }, ref) => {
  echarts.use([TooltipComponent, GridComponent, SVGRenderer, VisualMapComponent, GraphicComponent, ...charts]);

  return <ReactEChartsCore {...props} echarts={echarts} ref={ref} />
});

export default Echart;
